import React, { Component } from 'react';
import Parser from 'html-react-parser'
import { ChevronLeftIcon, ChevronRightIcon, DocumentIcon } from './SVGIcons';

import OffcanvasForm from './OffcanvasForm';

class First extends Component {
  static defaultProps = {
    productsPerPage: 10 // количество товаров на странице
  }

  state = {
    showCallForm: false,
    currentPage: 1
  }

  constructor(props) {
    super(props);
  }

  // Метод для открытия формы заказа звонка
  openCallForm = () => {
    this.setState({ showCallForm: true });
  };

  // Метод для закрытия формы заказа звонка
  closeCallForm = () => {
    this.setState({ showCallForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    // Закрываем Offcanvas меню
    this.props.hide();
    // Показываем сообщение об успехе
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  // Генерация 15 товаров
  generateProducts = () => {
    const products = [];
    const productNames = [
      '40 EAST DRAGON G 12+ (красный)',
      '50 EAST DRAGON G 12+ (зеленый)',
      '60 EAST DRAGON G 12++ (синий)',
      '70 EAST DRAGON G 13 (оранжевый)',
      '80 EAST DRAGON G 11 (желтый)',
      '90 EAST DRAGON G 12 (фиолетовый)',
      '100 EAST DRAGON G 12+ (розовый)',
      '110 EAST DRAGON G 13 (бордовый)',
      '120 EAST DRAGON G 11 (золотой)',
      '130 EAST DRAGON G 12 (серебряный)',
      '140 EAST DRAGON G 12+ (бронзовый)',
      '150 EAST DRAGON G 13 (черный)',
      '160 EAST DRAGON G 11 (белый)',
      '170 EAST DRAGON G 12 (серый)',
      '180 EAST DRAGON G 12+ (коричневый)'
    ];
    
    const productTypes = [
      'Антифриз', 'Тосол', 'Концентрат', 'Готовый состав', 
      'Премиум', 'Эконом', 'Зимний', 'Летний', 'Всесезонный'
    ];

    for (let i = 0; i < 15; i++) {
      products.push({
        id: i + 1,
        name: productNames[i % productNames.length],
        type: productTypes[i % productTypes.length],
        image: 'src/images/razdelcard.png',
        href: `/product/${i + 1}`
      });
    }
    
    return products;
  }

  // Обработка смены страницы
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
    // Прокрутка к началу списка
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // Получение товаров для текущей страницы
  getCurrentPageProducts = () => {
    const { productsPerPage } = this.props;
    const { currentPage } = this.state;
    const allProducts = this.props.data?.products || [];

    const startIndex = (currentPage - 1) * productsPerPage;
    const endIndex = startIndex + productsPerPage;

    return {
      products: allProducts.slice(startIndex, endIndex),
      totalPages: Math.ceil(allProducts.length / productsPerPage),
      totalItems: allProducts.length
    };
  }

  // Рендер пагинации
  renderPagination = () => {
    const { productsPerPage } = this.props;
    const { currentPage } = this.state;
    const totalItems = 15;
    const totalPages = Math.ceil(totalItems / productsPerPage);
    
    if (totalPages <= 1) return null;
    
    const getPageNumbers = () => {
      const pages = [];
      const maxVisible = 5;
      
      if (totalPages <= maxVisible) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        if (currentPage <= 3) {
          for (let i = 1; i <= 4; i++) pages.push(i);
          pages.push('...');
          pages.push(totalPages);
        } else if (currentPage >= totalPages - 2) {
          pages.push(1);
          pages.push('...');
          for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
        } else {
          pages.push(1);
          pages.push('...');
          for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
          pages.push('...');
          pages.push(totalPages);
        }
      }
      
      return pages;
    };
    
    return (
      <div className='w-full mt-[60px] flex items-center justify-center gap-[10px]'>
        {/* Кнопка "Назад" */}
        {currentPage > 1 && (
          <div 
            className='w-[38px] h-[38px] rounded-[14px] bg-[#F6F7F8] cursor-pointer flex items-center justify-center hover:bg-[#001553] group transition-colors'
            onClick={() => this.handlePageChange(currentPage - 1)}
          >
            <ChevronLeftIcon width={6} height={12} stroke="currentColor" className="group-hover:stroke-white" />
          </div>
        )}

        {/* Номера страниц */}
        <div className='flex items-center gap-[10px]'>
          {getPageNumbers().map((page, index) => (
            page === '...' ? (
              <div 
                key={`dots-${index}`} 
                className='w-[38px] h-[38px] rounded-[14px] cursor-default flex items-center justify-center text-[14px] text-[rgba(3,36,50,0.6)]'
              >
                ...
              </div>
            ) : (
              <div
                key={page}
                className={`w-[38px] h-[38px] rounded-[14px] cursor-pointer flex items-center justify-center text-[14px] transition-all ${
                  currentPage === page 
                    ? 'bg-[#001553] text-white' 
                    : 'bg-[#F6F7F8] hover:bg-[#001553] hover:text-white text-[rgba(3,36,50,0.6)]'
                }`}
                onClick={() => this.handlePageChange(page)}
              >
                {page}
              </div>
            )
          ))}
        </div>

        {/* Кнопка "Вперед" */}
        {currentPage < totalPages && (
          <div 
            className='w-[38px] h-[38px] rounded-[14px] bg-[#F6F7F8] cursor-pointer flex items-center justify-center hover:bg-[#001553] group transition-colors'
            onClick={() => this.handlePageChange(currentPage + 1)}
          >
            <ChevronRightIcon width={6} height={12} stroke="currentColor" className="group-hover:stroke-white" />
          </div>
        )}
      </div>
    );
  }

  render() {
    const { productsPerPage } = this.props;
    const data = this.props?.data || {};
    const { currentPage } = this.state;
    const { products, totalPages, totalItems } = this.getCurrentPageProducts();
    const { showCallForm } = this.state;
    
    // Определяем количество колонок в зависимости от количества товаров на странице
    const getGridCols = () => {
      //const count = products.length;
      //if (count === 1) return 'grid-cols-1';
      //if (count === 2) return 'grid-cols-2';
      //if (count <= 4) return 'grid-cols-2 md:grid-cols-4';
      return 'grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-7';
    };

    return (
      <>
        <div className='mt-[40px] w-full'>
          <div className='container'>
            <div className='uppercase tracking-tight text-title text-ptblack leading-none'>{Parser(data?.h1 || data?.pagetitle)}</div>
            <div className='bg-[#F6F7F8] rounded-[14px] leading-none text-base text-ptgray p-[20px] mt-[40px]'>
              {Parser(data?.introtext)}
            </div>

            {/* Сетка товаров */}
            <div className={`mt-[20px] grid ${getGridCols()} gap-[20px]`}>
              {products.map((product) => (
                <a href={product.href} key={product.id}>
                  <div className='w-full relative p-[20px] flex items-center justify-center h-[250px] bg-[#F6F7F8] rounded-[14px] group'>
                    <img src={product.image} width={168} height={210} alt={product.name} className='h-auto transition-transform duration-300 group-hover:scale-105' />
                    <div
                      className="w-[38px] h-[38px] rounded-[14px] flex items-center justify-center bg-white text-[#141414] cursor-pointer absolute right-[20px] bottom-[20px] hover:bg-[#001553] hover:text-white transition-colors"
                    >
                      <ChevronRightIcon width={6} height={12} stroke="currentColor" />
                    </div>
                  </div>
                  <div className='uppercase text-cardTitle text-ptblack leading-none mt-[20px]'>{product.name}</div>
                  <div className='text-base text-ptgray leading-none mt-[12px]'>{product.type}</div>
                </a>
              ))}
            </div>
            
            {/* Пагинация */}
            {totalPages > 1 && this.renderPagination()}
            
            {/* Информация о количестве товаров */}
            {totalItems > 0 && (
              <div className='mt-[20px] text-center text-sm text-ptgray/60'>
                Показано {products.length} из {totalItems} товаров
              </div>
            )}

            {/* Блок с ценами */}
            <div style={{ backgroundImage: `url('src/images/ceni2_bg.png')` }} className='bg-cover bg-center w-full mt-[60px] bg-[#001553] rounded-[14px] flex items-center justify-between gap-[19px] p-[20px] flex-wrap md:flex-nowrap'>
              <div className='leading-none'>
                <div className='text-white font-light leading-none text-cardTitle uppercase'>Нужны цены и условия поставки?</div>
                <div className='mt-[12px] text-base text-white/60 max-w-[568px]'>
                  Оставьте запрос — <span className='text-white'>подготовим коммерческое предложение</span> под ваш 
                  объём, тару и регион. <span className='text-white'>Приложим документы</span> на продукцию и <span className='text-white'>уточним 
                  сроки</span> отгрузки.
                </div>
              </div>
              <div onClick={() => this.openCallForm()} className='cursor-pointer max-w-[343px] flex-auto bg-[#BC0005] duration-300 ease-in-out hover:bg-[#930105] px-[22px] h-[48px] flex items-center justify-center rounded-[14px] gap-[12px] text-white hover:bg-[#8B0005] transition-colors'>
                <DocumentIcon width={16} height={16} stroke="currentColor" />
                <div className='text-base'>Запросить КП</div>
              </div>
            </div>
          </div>
        </div>

        {/* Форма заказа звонка */}
        <OffcanvasForm
          show={showCallForm}
          hide={this.closeCallForm}
          formTitle="Запросить коммерческое предложение"
          formText="Укажите контактные данные и количество — подготовим КП по выбранному товару. Если нужна доставка, добавьте адрес: рассчитаем условия и сроки под ваш регион."
          productName={(data?.pagetitle || '').replace(/(<([^>]+)>)/gi, "")} // Можно передать название товара, если нужно
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    )
  }
}

export default First;